module.exports = __webpack_public_path__ + "static/media/codebar_warning.920e8433.svg";